export default {
      id: "Icon--menu-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--menu",
      toString: function () {
        return this.url;
      }
    }